import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 28.8a12.8 12.8 0 1 1 0-25.6 12.8 12.8 0 0 1 0 25.6m0-23.2a10.4 10.4 0 1 0 0 20.8 10.4 10.4 0 0 0 0-20.8m0 16.8a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 1 1 0 3.2m0-12.8q1.6.2 1.6 1.7l-.4 5.2a1.2 1.2 0 0 1-2.4 0l-.4-5.2A1.6 1.6 0 0 1 16 9.6" })
});
export default SvgExclamationRegularIcon;
